var _style, _path, _path2, _path3, _path4, _path5, _path6, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoKintoBrasil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 482.5 62",
    style: {
      enableBackground: "new 0 0 482.5 62"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{enable-background:new    ;}\n\t.st2{fill:#ABD3DB;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88,14h10.2c3.2,0,5.3,1.5,7.5,4.5l16.8,26.9h0.1V14h5c2.6,0,4.7,2,4.7,4.7v42.2h-3.8c-4.5,0-6.6-1-9.4-4.7 l-16.6-26.7h-0.1v31.4h-5c-2.5,0-4.7-1.8-4.7-4.7V18.6C92.6,16.1,90.6,14,88,14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M142.5,14h38.4c2.8,0,4.7,2.2,4.7,4.7v4.7h-14v37.5h-5.6c-2.6,0-4.7-1.8-4.7-4.7V23.4h-9.4 c-2.7,0-4.7-2-4.7-4.7C147.1,16.1,145.2,14,142.5,14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61,56.2V24.9h5.7c2.5,0,4.7,1.9,4.7,4.7v31.2h-5.7C63.1,60.8,61,58.8,61,56.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.7,18.6v37.5c0,2.6,2,4.7,4.7,4.7H15V43.6l0,0l12.9,13.2c3.8,3.7,6.2,4.1,9.4,4.1h7.5L21.2,37.4L44.8,14H31.9 L15,31.2l0,0l0-12.6c0-2.3-1.9-4.7-4.7-4.7H0C2.5,14,4.7,16.3,4.7,18.6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.3,12.9c-13.6,0-24.5,11-24.5,24.5c0,13.6,11,24.5,24.5,24.5c13.6,0,24.5-11,24.5-24.5 C242.9,23.9,231.9,12.9,218.3,12.9 M218.3,52.5c-8.4,0-15.1-6.8-15.1-15.1c0-8.4,6.8-15.1,15.1-15.1c8.4,0,15.1,6.8,15.1,15.1 C233.5,45.8,226.7,52.5,218.3,52.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.5,9.3c-1.4-1.1-3.5-1.3-5.4,0c-2.6,1.8-2.9,5-1.5,7.5c1.4,2.5,4,3.4,7,3.1c3.4-0.3,6.1-2.2,7.7-4.3 c1.4-1.9,3-6.6-0.1-11.1C71.9,1.1,68.9,0,65.7,0c-3.6,0-6,2.7-7.7,4.7c-2.6,3.1-3.8,3.8-6.1,4c-2.3,0.2-4.4-0.8-5.4-1.8 c-1-1.1-1.6-1.9-1.6-1.9s1.3,2.4,3,3.8c1.8,1.5,4.6,2.3,7.7,1.2c3.6-1.3,5.5-3.5,6.7-4.2c2.4-1.4,5.8-0.3,6.5,2.2 c0.8,2.9-0.8,4.9-0.8,4.9S68.5,10.8,66.5,9.3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M297.4,47.8c0,7.6-5.4,13-14.4,13h-18.8V14h16.4c9,0,14.3,4.8,14.3,11.9c0,4.2-1.8,8-6.3,10.4 C293.9,37.5,297.4,41.7,297.4,47.8z M273.1,33.8h6.7c4.4,0,6.7-2.8,6.7-6.3c0-3.8-2.6-6.1-7.1-6.1h-6.3V33.8z M288.5,46.9 c0-3.9-2.6-6.1-6.7-6.1h-8.6v12.7h8.2C285.8,53.5,288.5,51,288.5,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M320.7,42.5H315v18.3h-8.9V14h16.4c10,0,15.6,5.9,15.6,13.7c0,5.7-3,10.8-8.8,13.3l12.9,19.9h-10.5 L320.7,42.5z M315,35.5h6.1c4.2,0,7.7-2.2,7.7-7.2c0-4.9-3.4-6.9-7.6-6.9H315V35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M374.2,47.6h-16.8l-4.6,13.2h-9L361.2,14h9.6l17.4,46.8h-9.4L374.2,47.6z M371.7,40.5l-5.9-16.8l-5.9,16.8 H371.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M391.3,56.8l2.3-8.2c3.6,2.8,8.8,4.9,13.7,4.9c4.7,0,7.2-2,7.2-5.6s-2.9-4.8-9.2-7.1c-7.5-2.8-13-6-13-13.8 c0-8.6,6.6-13.8,16.2-13.8c5.1,0,10.4,1.5,13.6,3.2l-2.5,7.7c-3.1-1.8-7.5-3-11.1-3c-4.3,0-7.1,1.9-7.1,5.1c0,3.7,3.7,5.1,9.3,7.2 c7.4,2.7,12.9,5.1,12.9,13.5c0,9.3-6.6,14.6-16.7,14.6C401.2,61.5,395.5,59.7,391.3,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M432.6,14h8.9v46.8h-8.9V14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M480.7,52.8v8h-27.8V14h8.9v38.9H480.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKintoBrasil);
export default __webpack_public_path__ + "static/media/LogoKintoBrasil.2d42cae6ee8fcb159ad349175e6267e0.svg";
export { ForwardRef as ReactComponent };